import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

export interface UpdateUserRequest {
  fullName: string;
  email: string;
  countryCode?: number;
  phoneNumber?: number;
  password?: string;
}

export interface UpdateUserResponse {
  message?: string;
  data?: unknown;
  [key: string]: unknown;
}

export const updateUser = async (
  userId: string,
  payload: UpdateUserRequest
): Promise<UpdateUserResponse> => {
  const response = await api.update(`/api/v1/users/${userId}`, payload);
  return response as unknown as UpdateUserResponse;
};

